import React from 'react';
import PetugasKeamananIcon from '../images/petugas-keamanan.svg'
import PendidikanPelatihan from '../images/pendidikan-pelatihan.svg'
import Peralatan from '../images/peralatan.svg'
import K9Unit from '../images/k9-unit.svg'
import MonitoringControlling from '../images/monitoring-controlling.svg'
import SectionHeading from './SectionHeading';

const products = [
    { icon: PetugasKeamananIcon, title: 'Petugas Keamanan' },
    { icon: PendidikanPelatihan, title: 'Pendidikan & Pelatihan' },
    { icon: Peralatan, title: 'Peralatan (Equipment)' },
    { icon: K9Unit, title: 'K9-Unit (K9-Team)' },
    { icon: MonitoringControlling, title: 'Monitoring Controlling' },
];

const Product = () => {
    return (
        <div id="services" className="bg-gray-50 py-16 md:py-20">
            <section data-aos="zoom-in-down" className="container-app">
                <SectionHeading
                    eyebrow="Produk Kami"
                    title="Produk"
                    subtitle="Kami menawarkan berbagai produk unggulan dari sistem kami"
                />

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5" data-aos="fade-up" data-aos-delay="200">
                    {products.map(({ icon, title }) => (
                        <div key={title} className="card group flex flex-col items-center text-center px-4 py-8">
                            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-brand/10 mb-4 transition-transform duration-300 group-hover:scale-110">
                                <img alt={title} className="w-9 h-9 object-contain" src={icon} />
                            </div>
                            <h3 className="font-semibold text-base text-slate-800 leading-snug">{title}</h3>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}

export default Product;
